import { SingleToolCard } from '@quicktools/shared-components/components/common/SingleToolCard';
import {
  ButtonToggle,
  ButtonToggleOption,
} from '@quicktools/shared-components/components/core/ButtonToggle';
import WithScrollbarArrows from '@quicktools/shared-components/components/core/WithScrollbarArrows';
import { MouseEvent, useState } from 'react';
import { Text, TextElementTypes } from '@picsart/text';
import { Typography, FontWeights } from '@picsart/cascade';
import { useTranslation } from 'react-i18next';

import OpenAiWriterButton from '../../GenerateExample/OpenAiWriterButton';
import analytics from '../../../../services/analytics';
import CardButtons from '../CardButtons';

import { TOOLS, CardCategory, cardCategoryToText } from './data';
import useStyles from './styles';

const CATEGORIES = Object.keys(TOOLS);

function CopywriterToolsSection() {
  const classes = useStyles();
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState<CardCategory>(CardCategory.All);

  const handleFindMoreClick = (event: MouseEvent<HTMLButtonElement>, url: string, id: string) => {
    event.preventDefault();
    event.stopPropagation();
    analytics.pillarToolSelect({
      page_path: window.location.pathname,
      action_type: id,
      button_type: 'learn_more',
    });
    window.open(url);
  };
  const handleArrowClick = (event: MouseEvent<HTMLButtonElement>, url: string, id: string) => {
    event.preventDefault();
    event.stopPropagation();
    analytics.pillarToolSelect({
      page_path: window.location.pathname,
      action_type: id,
      button_type: 'arrow_button',
    });
    window.open(url);
  };

  return (
    <div className={classes.root} id="CopywriterToolsSection">
      <div className={classes.container}>
        <div className={classes.header}>
          <Text
            className={classes.title}
            elementType={TextElementTypes.H2}
            weight={FontWeights.Medium}
            size={Typography.t10}
          >
            {t('generalLanding.tools.title')}
          </Text>
          <Text
            className={classes.description}
            elementType={TextElementTypes.Paragraph}
            weight={FontWeights.Medium}
            size={Typography.t5}
          >
            {t('generalLanding.tools.description')}
          </Text>
        </div>

        <WithScrollbarArrows
          arrowRightSrc="https://cdn140.picsart.com/35518528391861103203.svg"
          arrowLeftSrc="https://cdn140.picsart.com/94267810475352279696.svg"
        >
          <ButtonToggle
            className={classes.buttonToggle}
            onChange={(value) => setSelectedCategory(value)}
            value={selectedCategory}
          >
            {CATEGORIES.map((category) => (
              <ButtonToggleOption
                textColor={
                  category === selectedCategory ? 'var(--x-accent-2-1)' : 'var(--x-text-color-4)'
                }
                key={category}
                value={category}
              >
                {cardCategoryToText[category]}
              </ButtonToggleOption>
            ))}
          </ButtonToggle>
        </WithScrollbarArrows>

        <div className={classes.cards}>
          {TOOLS[selectedCategory].map(
            ({
              name,
              description: toolDescription,
              href,
              icon,
              id,
              isNew = false,
              buttonHref = '',
            }) => (
              <SingleToolCard
                showDescription
                hasNewLabel={isNew}
                key={id}
                onClick={() => {
                  analytics.pillarToolSelect({
                    page_path: window.location.pathname,
                    action_type: id,
                    button_type: 'card',
                  });
                }}
                href={href}
                icon={icon}
                name={name}
                description={toolDescription}
                cta={
                  <CardButtons
                    handleFindMoreClick={
                      buttonHref
                        ? (event: MouseEvent<HTMLButtonElement>) => {
                            handleFindMoreClick(event, buttonHref, id);
                          }
                        : undefined
                    }
                    handleArrowClick={(event: MouseEvent<HTMLButtonElement>) => {
                      handleArrowClick(event, href, id);
                    }}
                  />
                }
              />
            ),
          )}
        </div>
        <div className={classes.openBtnContainer}>
          <OpenAiWriterButton />
        </div>
      </div>
    </div>
  );
}

export default CopywriterToolsSection;
